// Consent gate for analytics. Nothing is tracked until the visitor accepts —
// see lib/analytics.ts, which no-ops while consent is absent or denied.
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { flushPending, getConsent, setConsent } from '../../lib/analytics';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only ask if they haven't already decided.
    if (getConsent() === null) setVisible(true);
  }, []);

  if (!visible) return null;

  const decide = (value: 'granted' | 'denied') => {
    setConsent(value);
    setVisible(false);
    // Don't lose the view that was already underway while they decided.
    if (value === 'granted') flushPending();
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      style={{
        position: 'fixed', left: 'var(--space-4)', right: 'var(--space-4)', bottom: 'var(--space-4)',
        zIndex: 9999, maxWidth: 640, margin: '0 auto',
        display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 'var(--space-4)',
        padding: 'var(--space-4) var(--space-5)',
        background: 'rgba(12,12,14,0.94)', backdropFilter: 'blur(12px)',
        border: '1px solid var(--color-border-light)', borderRadius: 14,
        boxShadow: '0 12px 40px rgba(0,0,0,0.5)',
      }}
    >
      <p style={{ flex: '1 1 260px', margin: 0, fontSize: 13, lineHeight: 1.6, color: 'var(--color-text-70)' }}>
        This site stores a session identifier and records your IP address and
        approximate location to measure traffic.{' '}
        <Link to="/privacy" style={{ color: 'var(--color-accent)' }}>Privacy Policy</Link>
      </p>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button
          onClick={() => decide('denied')}
          style={{
            padding: '8px 16px', borderRadius: 9, cursor: 'pointer', fontSize: 13,
            background: 'transparent', color: 'var(--color-text-70)',
            border: '1px solid var(--color-border-light)',
          }}
        >
          Decline
        </button>
        <button
          onClick={() => decide('granted')}
          style={{
            padding: '8px 16px', borderRadius: 9, cursor: 'pointer', fontSize: 13,
            fontWeight: 700, background: 'var(--color-accent)', color: '#000', border: 'none',
          }}
        >
          Accept
        </button>
      </div>
    </div>
  );
}
